import { LitElement, html } from '@hh/global.js'

class HHLoadMore extends LitElement {

  static properties = {
    url: {
      type: String
    },
    direction: {
      type: String,
    },
    targetClass: {
      type: String,
      attribute: 'target-class'
    },
    ctx: {
      type: String,
    }
  }

  constructor() {
    super()
    this.direction = 'next'
    this.ctx = 'collection'
  }

  handleLoadMore() {

    this.setLoadingState()

    fetch(this.url)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status)
          console.error(error)
          this.setLoadingState(false)
        }

        return response.text()
      }).then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
        document.querySelector(this.targetClass)
          .insertAdjacentHTML(this.direction === 'previous' ? 'afterbegin' : 'beforeend',
          resultsMarkup.querySelector(this.targetClass).innerHTML)
        this.renderLoadMore(resultsMarkup)
      }).catch((error) => {
        console.error(error)
        this.setLoadingState(false)
      })
  }

  renderLoadMore(resultsMarkup) {
    if (!resultsMarkup) return
    const elId = `#${this.getAttribute('id')}`;
    const refreshedLoadMore = resultsMarkup.querySelector(elId)?.outerHTML || ''
    this.outerHTML = refreshedLoadMore

    if (this.direction === 'next') {
      this.updatePageURL()
    }
  }

  updatePageURL() {
    window.history.pushState({}, '', this.url)
  }

  setLoadingState(isLoading = true) {
    const loadMoreButton = this.querySelector('hh-button')
    if (loadMoreButton) {
      if (isLoading) {
        loadMoreButton.classList.add('is-loading')
        loadMoreButton.setAttribute('disabled', true)
      } else {
        loadMoreButton.classList.remove('is-loading')
        loadMoreButton.removeAttribute('disabled')
      }
    }
  }

  render() {
    return html` <slot @loadMore="${this.handleLoadMore}"></slot> `
  }
}

customElements.define('hh-load-more', HHLoadMore)
